import getAll from 'utils/getAll'
import { apiUrls } from 'consts'
import { axiosGet } from 'shared/api/axios'

interface getRowsReturnType {
  customers: Array<any>
  selectedCustomer: any | null
}

const getRows = async (): Promise<getRowsReturnType> => {
  const customers = await getAll(apiUrls.customers + '/' + apiUrls.actionMyCustomers)
  const selectedCustomer = await axiosGet(
    apiUrls.customers + '/' + apiUrls.actionGetSelectedCustomer,
  )

  return {
    customers: customers,
    selectedCustomer: selectedCustomer,
  } as getRowsReturnType
}

export default getRows
